<template>
  <div>
      <vs-prompt :active.sync="is_active" :color="errorConfig.color" :title="errorConfig.title"
          :buttonsHidden="errorConfig.hideButtons">
          <div class="error-container">
              <vs-icon :icon="dialogIcon" icon-pack="feather" class="dialog-icon" />
              <div class="error-message" v-html="errorConfig.messageTemplate"></div>
          </div>
      </vs-prompt>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
      return {
          open: true
      }
  },
  computed: {
      ...mapGetters(['systemError']),
      is_active: {
          get() {
              return this.systemError.is_active;
          },
          set(value) {
              this.updateSystemError({
                  is_active: false,
                  errorTemplate: ''
              })
          }
      },
      errorConfig() {
          let messageTemplate = this.systemError.messageTemplate
              ? this.systemError.messageTemplate
              : "Something went wrong!";
          messageTemplate = this.cleanErrorMessage(messageTemplate);

          return {
              color: this.systemError.color ? this.systemError.color : "danger",
              title: this.systemError.title ? this.systemError.title : "An Error Occurred",
              messageTemplate: messageTemplate,
              hideButtons: this.systemError.hideButtons ? this.systemError.hideButtons : true,
              buttonText: this.systemError.buttonText ? this.systemError.buttonText : "Close"
          };
      },
      dialogIcon() {
          switch (this.systemError.color) {
              case "danger":
                  return "icon-alert-octagon";
              case "warning":
                  return "icon-alert-triangle";
              case "success":
                  return "icon-check-circle";
              case "primary":
                  return "icon-info";
              default:
                  return "icon-help-circle";
          }
      }

  },
  methods: {
      ...mapActions(['updateSystemError']),
      cleanErrorMessage(msg) {
          if (!msg) return msg;

          // extract plain text before <ul> safely (no optional chaining)
          const parts = msg.split('<br><br>')
          const mainMessage = parts.length > 0 ? parts[0].trim() : ''

          const listContentMatch = msg.match(/<ul[^>]*>([\s\S]*?)<\/ul>/i)

          if (listContentMatch) {
              const listText = listContentMatch[1].replace(/<[^>]*>/g, '').trim()

              // If main message and list text are the same → show single clean list
              if (listText === mainMessage) {
                  return `<ul style="list-style-type:circle; margin-left:15px"><li>${mainMessage}</li></ul>`
              } else {
                  // Otherwise, keep as is (multiple errors)
                  return msg
              }
          }

          return msg
      }

  }
}
</script>
<style scoped>
.error-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dialog-icon {
  font-size: 52px;
  color: inherit;
}

.error-message {
  max-height: 200px;
  overflow-y: auto;
  word-wrap: break-word;
  font-size: 14px;
  padding-top: 18px;
  margin-bottom: 2px;
}
</style>